export default class Error {
  constructor () {
    this.reset()
  }

  reset () {
    this.error = false
    this.contact = false
    this.heading = this.text = this.title = ''
  }

  set (title, heading, text, contact) {
    this.error = true
    this.heading = heading
    this.text = text
    this.title = title
    this.contact = contact !== false
  }
}
